export default __webpack_public_path__ + "static/slide2-mobile-788d6318780917b80378d891aad40384.png";